export default "__VITE_ASSET__3cb9a19a__"